const isValidDate = (maybeDate) =>
  maybeDate instanceof Date && maybeDate.getTime() !== 0

export default isValidDate
